'use client';

import Image from 'next/image';
import { useParams } from 'next/navigation';
import { LangLink } from '../../../i18n/links';
import { defaultLang, SUPPORTED } from '../../../config/languages';
import { solutions } from '../solutions/solutions';
import PopularPosts from '../../Blog/SingleLayout2/PopularPosts';

export default function SolutionSidebar({ currentId, popularTitle, guidesTitle }) {
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const otherSolutions = solutions.filter((item) => String(item.id) !== String(currentId));

  return (
    <aside className="single-blog-v2-sidebar solution-v2-sidebar">
      <section className="single-blog-v2-popular-card solution-v2-other-card">
        <div className="single-blog-v2-popular-heading">
          <span className="single-blog-v2-popular-mark" aria-hidden="true" />
          <h2>{popularTitle}</h2>
        </div>
        <div className="solution-v2-other-list">
          {otherSolutions.map((item) => {
            const tr = item.translations?.[activeLang] || item.translations?.en || item;
            const slug = typeof item.slug === 'object' ? (item.slug[activeLang] || item.slug.en) : item.slug;
            return (
              <LangLink to={`/solutions/${slug}`} className="solution-v2-other-item" key={item.id}>
                <span className="solution-v2-other-image"><Image src={item.image} alt="" fill sizes="86px" /></span>
                <strong>{tr.title || item.title}</strong>
              </LangLink>
            );
          })}
        </div>
      </section>
      <div className="single-blog-v2-popular solution-v2-guides">
        <PopularPosts title={guidesTitle} max={12} />
      </div>
    </aside>
  );
}
